export default {
  title: 'Viimeisimpien kampanjoiden tulokset',
  recipients: '{{recipients}} vastaanottajaa',
  error_messages: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
